import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Claims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.claims_Id,
          sortable: true,
          cell: (row) => <span>{row.claims_Id}</span>,
        },
        { name: "Claim Id", selector: (row, i) => row.claimId, sortable: true, cell: (row) => <span>{row.claimId}</span>, }, { name: "Member Id", selector: (row, i) => row.memberId, sortable: true, cell: (row) => <span>{row.memberId}</span>, }, { name: "Claim Amount", selector: (row, i) => row.claimAmount, sortable: true, cell: (row) => <span>{row.claimAmount}</span>, }, { name: "Claim Status", selector: (row, i) => row.claimStatus, sortable: true, cell: (row) => <span>{row.claimStatus}</span>, }, { name: "Approved Amount", selector: (row, i) => row.approvedAmount, sortable: true, cell: (row) => <span>{row.approvedAmount}</span>, }, { name: "Remarks", selector: (row, i) => row.remarks, sortable: true, cell: (row) => <span>{row.remarks}</span>, }, { name: "Deductions", selector: (row, i) => row.deductions, sortable: true, cell: (row) => <span>{row.deductions}</span>, }, { name: "Firstapproval Status", selector: (row, i) => row.firstapprovalStatus, sortable: true, cell: (row) => <span>{row.firstapprovalStatus}</span>, }, { name: "Firstapproval Remarks", selector: (row, i) => row.firstapprovalRemarks, sortable: true, cell: (row) => <span>{row.firstapprovalRemarks}</span>, }, { name: "Secondapproval Status", selector: (row, i) => row.secondapprovalStauts, sortable: true, cell: (row) => <span>{row.secondapprovalStauts}</span>, }, { name: "Secondapproval Remarks", selector: (row, i) => row.secondapprovalRemarks, sortable: true, cell: (row) => <span>{row.secondapprovalRemarks}</span>, }, { name: "Finalapproval Status", selector: (row, i) => row.finalapprovalStatus, sortable: true, cell: (row) => <span>{row.finalapprovalStatus}</span>, }, { name: "Final Approval Remarks", selector: (row, i) => row.finalapprovalRemarks, sortable: true, cell: (row) => <span>{row.finalapprovalRemarks}</span>, }, { name: "Dummy One", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "Dummy Two", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "Dummy Three", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, }, { name: "Dummy Four", selector: (row, i) => row.dummyFour, sortable: true, cell: (row) => <span>{row.dummyFour}</span>, }, { name: "Dummy Five", selector: (row, i) => row.dummyFive, sortable: true, cell: (row) => <span>{row.dummyFive}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ClaimseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      claims_Id: "",
      claimId: '', memberId: '', claimAmount: '', claimStatus: '', approvedAmount: '', remarks: '', deductions: '', firstapprovalStatus: '', firstapprovalRemarks: '', secondapprovalStauts: '', secondapprovalRemarks: '', finalapprovalStatus: '', finalapprovalRemarks: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, claimId: '', memberId: '', claimAmount: '', claimStatus: '', approvedAmount: '', remarks: '', deductions: '', firstapprovalStatus: '', firstapprovalRemarks: '', secondapprovalStauts: '', secondapprovalRemarks: '', finalapprovalStatus: '', finalapprovalRemarks: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, claimId: '', memberId: '', claimAmount: '', claimStatus: '', approvedAmount: '', remarks: '', deductions: '', firstapprovalStatus: '', firstapprovalRemarks: '', secondapprovalStauts: '', secondapprovalRemarks: '', finalapprovalStatus: '', finalapprovalRemarks: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  ClaimseditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true, claims_Id: row.claims_Id, claimId: row.claimId, memberId: row.memberId, claimAmount: row.claimAmount, claimStatus: row.claimStatus, approvedAmount: row.approvedAmount, remarks: row.remarks, deductions: row.deductions, firstapprovalStatus: row.firstapprovalStatus, firstapprovalRemarks: row.firstapprovalRemarks, secondapprovalStauts: row.secondapprovalStauts, secondapprovalRemarks: row.secondapprovalRemarks, finalapprovalStatus: row.finalapprovalStatus, finalapprovalRemarks: row.finalapprovalRemarks, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree, dummyFour: row.dummyFour, dummyFive: row.dummyFive, //***editstate
    });
  }

  ClaimsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Claims/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  ClaimssubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('claimId', this.state.claimId);
    formData.append('memberId', this.state.memberId);
    formData.append('claimAmount', this.state.claimAmount);
    formData.append('claimStatus', this.state.claimStatus);
    formData.append('approvedAmount', this.state.approvedAmount);
    formData.append('remarks', this.state.remarks);
    formData.append('deductions', this.state.deductions);
    formData.append('firstapprovalStatus', this.state.firstapprovalStatus);
    formData.append('firstapprovalRemarks', this.state.firstapprovalRemarks);
    formData.append('secondapprovalStauts', this.state.secondapprovalStauts);
    formData.append('secondapprovalRemarks', this.state.secondapprovalRemarks);
    formData.append('finalapprovalStatus', this.state.finalapprovalStatus);
    formData.append('finalapprovalRemarks', this.state.finalapprovalRemarks);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Claims/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ClaimsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ claimId: '', memberId: '', claimAmount: '', claimStatus: '', approvedAmount: '', remarks: '', deductions: '', firstapprovalStatus: '', firstapprovalRemarks: '', secondapprovalStauts: '', secondapprovalRemarks: '', finalapprovalStatus: '', finalapprovalRemarks: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  ClaimsupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("claims_Id", this.state.claims_Id);
    formData.append('claimId', this.state.claimId);
    formData.append('memberId', this.state.memberId);
    formData.append('claimAmount', this.state.claimAmount);
    formData.append('claimStatus', this.state.claimStatus);
    formData.append('approvedAmount', this.state.approvedAmount);
    formData.append('remarks', this.state.remarks);
    formData.append('deductions', this.state.deductions);
    formData.append('firstapprovalStatus', this.state.firstapprovalStatus);
    formData.append('firstapprovalRemarks', this.state.firstapprovalRemarks);
    formData.append('secondapprovalStauts', this.state.secondapprovalStauts);
    formData.append('secondapprovalRemarks', this.state.secondapprovalRemarks);
    formData.append('finalapprovalStatus', this.state.finalapprovalStatus);
    formData.append('finalapprovalRemarks', this.state.finalapprovalRemarks);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Claims/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ClaimsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.ClaimsfetchHandler();

    //***componentDidMount
  }
  handleclaimIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ claimId: fieldValue });
  }; handlememberIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberId: fieldValue });
  }; handleclaimAmountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ claimAmount: fieldValue });
  }; handleclaimStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ claimStatus: fieldValue });
  }; handleapprovedAmountChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approvedAmount: fieldValue });
  }; handleremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  }; handledeductionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deductions: fieldValue });
  }; handlefirstapprovalStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ firstapprovalStatus: fieldValue });
  }; handlefirstapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ firstapprovalRemarks: fieldValue });
  }; handlesecondapprovalStautsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ secondapprovalStauts: fieldValue });
  }; handlesecondapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ secondapprovalRemarks: fieldValue });
  }; handlefinalapprovalStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ finalapprovalStatus: fieldValue });
  }; handlefinalapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ finalapprovalRemarks: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  }; handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  }; handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('claims_Id', row.claims_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Claims/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ClaimsfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Claims </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Claims</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Claim Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclaimIdChange} className="form-control" name="claimId" value={this.state.claimId} required="required" placeholder="Enter Claim Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Member Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlememberIdChange} className="form-control" name="memberId" value={this.state.memberId} required="required" placeholder="Enter Member Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.memberId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Claim Amount</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclaimAmountChange} className="form-control" name="claimAmount" value={this.state.claimAmount} required="required" placeholder="Enter Claim Amount" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimAmount} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Claim Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclaimStatusChange} className="form-control" name="claimStatus" value={this.state.claimStatus} required="required" placeholder="Enter Claim Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimStatus} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Approved Amount</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleapprovedAmountChange} className="form-control" name="approvedAmount" value={this.state.approvedAmount} required="required" placeholder="Enter Approved Amount" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.approvedAmount} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Remarks</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleremarksChange} className="form-control" name="remarks" value={this.state.remarks} required="required" placeholder="Enter Remarks" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.remarks} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Deductions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledeductionsChange} className="form-control" name="deductions" value={this.state.deductions} required="required" placeholder="Enter Deductions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.deductions} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Firstapproval Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefirstapprovalStatusChange} className="form-control" name="firstapprovalStatus" value={this.state.firstapprovalStatus} required="required" placeholder="Enter Firstapproval Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.firstapprovalStatus} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Firstapproval Remarks</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefirstapprovalRemarksChange} className="form-control" name="firstapprovalRemarks" value={this.state.firstapprovalRemarks} required="required" placeholder="Enter Firstapproval Remarks" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.firstapprovalRemarks} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Secondapproval Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesecondapprovalStautsChange} className="form-control" name="secondapprovalStauts" value={this.state.secondapprovalStauts} required="required" placeholder="Enter Secondapproval Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.secondapprovalStauts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Secondapproval Remarks</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlesecondapprovalRemarksChange} className="form-control" name="secondapprovalRemarks" value={this.state.secondapprovalRemarks} required="required" placeholder="Enter Secondapproval Remarks" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.secondapprovalRemarks} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Finalapproval Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefinalapprovalStatusChange} className="form-control" name="finalapprovalStatus" value={this.state.finalapprovalStatus} required="required" placeholder="Enter Finalapproval Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.finalapprovalStatus} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Final Approval Remarks</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlefinalapprovalRemarksChange} className="form-control" name="finalapprovalRemarks" value={this.state.finalapprovalRemarks} required="required" placeholder="Enter Final Approval Remarks" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.finalapprovalRemarks} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                  </Row><br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ClaimssubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Claims</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Claim Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclaimIdChange} className="form-control" name="claimId" value={this.state.claimId} required="required" placeholder="Enter Claim Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Member Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlememberIdChange} className="form-control" name="memberId" value={this.state.memberId} required="required" placeholder="Enter Member Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.memberId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Claim Amount</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclaimAmountChange} className="form-control" name="claimAmount" value={this.state.claimAmount} required="required" placeholder="Enter Claim Amount" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimAmount} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Claim Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclaimStatusChange} className="form-control" name="claimStatus" value={this.state.claimStatus} required="required" placeholder="Enter Claim Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claimStatus} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Approved Amount</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleapprovedAmountChange} className="form-control" name="approvedAmount" value={this.state.approvedAmount} required="required" placeholder="Enter Approved Amount" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.approvedAmount} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Remarks</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleremarksChange} className="form-control" name="remarks" value={this.state.remarks} required="required" placeholder="Enter Remarks" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.remarks} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Deductions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledeductionsChange} className="form-control" name="deductions" value={this.state.deductions} required="required" placeholder="Enter Deductions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.deductions} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Firstapproval Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefirstapprovalStatusChange} className="form-control" name="firstapprovalStatus" value={this.state.firstapprovalStatus} required="required" placeholder="Enter Firstapproval Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.firstapprovalStatus} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Firstapproval Remarks</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefirstapprovalRemarksChange} className="form-control" name="firstapprovalRemarks" value={this.state.firstapprovalRemarks} required="required" placeholder="Enter Firstapproval Remarks" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.firstapprovalRemarks} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Secondapproval Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesecondapprovalStautsChange} className="form-control" name="secondapprovalStauts" value={this.state.secondapprovalStauts} required="required" placeholder="Enter Secondapproval Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.secondapprovalStauts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Secondapproval Remarks</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlesecondapprovalRemarksChange} className="form-control" name="secondapprovalRemarks" value={this.state.secondapprovalRemarks} required="required" placeholder="Enter Secondapproval Remarks" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.secondapprovalRemarks} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Finalapproval Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefinalapprovalStatusChange} className="form-control" name="finalapprovalStatus" value={this.state.finalapprovalStatus} required="required" placeholder="Enter Finalapproval Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.finalapprovalStatus} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Final Approval Remarks</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlefinalapprovalRemarksChange} className="form-control" name="finalapprovalRemarks" value={this.state.finalapprovalRemarks} required="required" placeholder="Enter Final Approval Remarks" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.finalapprovalRemarks} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                    </Row><br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ClaimsupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
